import React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter, Link} from 'react-router-dom';
import './stylesheets/gameComplete.scss'
import Language from '../language/language';

@inject('gameStore', 'teamStore', 'languageStore')
@withRouter
@observer
export default class GameComplete extends React.Component {
  componentDidMount() {
    // this.props.gameStore.getGameDetailInfo()
    if (!this.props.gameStore.gameComplete) {
      this.props.history.push('/control-center')
    }
  }
  render () {
    const gameComplete = this.props.gameStore.gameComplete
    const lang = this.props.languageStore.lang
    if (!gameComplete || !gameComplete[lang]) {
      return null
    }
    
    const content = JSON.parse(gameComplete[lang])
    return (
      <div className="game-complete">
        <div className="title">
          {content.title}
        </div>
        <div className="sub-title">
          {content.subTitle}
        </div>
        <div className="desc" dangerouslySetInnerHTML={{
          __html: content.content
        }} />

        <Link className="back-game" to={this.props.teamStore.teamInfo.id ? `/game-apply-info/${this.props.teamStore.teamInfo.id}` : '/control-center'}>
          <Language resource="RETURN_GAME_APPLY" />
        </Link>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/game/gameComplete.js